import React, { Component } from 'react';
import { Card, Button, Form, Badge, Dimmer, Table } from "tabler-react";
import _ from 'lodash';
import { findInventoryItems } from '../actions';
import ReactTooltip from 'react-tooltip';

class SearchItemSideBar extends Component {
  constructor() {
    super();
    this.state = {
      inventoryItems: {
        items: [],
        pagination: {
          nextPage: 1
        } 
      },
      isLoading: false,
      searchTerm: ''
    };

    this.searchItemSideBarRef = React.createRef();
    this.searchInputRef = React.createRef();

    this.handleSearchItem = this.handleSearchItem.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.trackScrolling = this.trackScrolling.bind(this);
  }

  truncate = (value, max, breakWord) => {
    if (value.length <= max) return value;
    let newValue = value.substr(0, max - 1);
    return `${!breakWord ? newValue.substr(0, newValue.lastIndexOf(' ')) : newValue}...`;
  };

  isImage(value) {
    if (!value) return true;
    value = value.toLowerCase();
    return value.match(/\.(jpeg|jpg|gif|png)$/) != null;
  }

  isBottom(element) {
    return element.scrollTop === (element.scrollHeight - element.offsetHeight);
  }

  trackScrolling() {
    if (!this.isBottom(this.searchItemSideBarRef.current)) return;
    this.handleSearchItem(this.state.searchTerm);
  }

  handleSearchItem(term) {
    if (term.length <= 0) return;
    if (this.state.isLoading) return;
    
    let { inventoryItems: { pagination: { nextPage } }, searchTerm } = this.state;

    if (searchTerm !== term) nextPage = 1;
    
    this.setState({ isLoading: true });
    
    findInventoryItems({ page: nextPage, perPage: 30, search: term, display: true }, (response) => {
      if (searchTerm !== term) {
        this.setState({ 
          inventoryItems: response.data,
          isLoading: false, 
          searchTerm: term 
        });
      }
      else {
        let { inventoryItems } = this.state;
        inventoryItems.items = [...inventoryItems.items, ...response.data.items];
        inventoryItems.pagination = response.data.pagination;
        this.setState({ 
          inventoryItems,
          isLoading: false, 
          searchTerm: term 
        });
      }
      
    }, () => {
      this.setState({ isLoading: false, searchTerm: '' });
    });
  }

  renderItem(data, index, onSelectItem) {
    return (
      <Table.Row key={index}>
        <Table.Col className="right-side-bar__image-col">
          {this.isImage(data.image.raw) &&
            <img alt="" src={data.image.url ? data.image.url : `https://ui-avatars.com/api/?name=${data.name}`} />
          }
          {!this.isImage(data.image.raw) &&
            <a href={data.image.url} target="_blank"><i className="fe fe-file" style={{ fontSize: '3em' }}></i></a>
          }
        </Table.Col>
        <Table.Col>
          <b className="d-block">{data.subItemCode}-{data.name}</b>
            {data.model &&
              <Badge color="primary" className="mr-1">
                <span data-tip={data.model}>{this.truncate(data.model, 30)}</span>
              </Badge>
            }
            {data.specification &&
              <Badge color="info" className="mr-1">
                <span data-tip={data.specification}>{this.truncate(data.specification, 30)}</span>
              </Badge>
            }
            {data.description &&
            <div>
              <Badge color="secondary" className="mr-1">
                  <span data-tip={data.description}>{this.truncate(data.description, 40)}</span>
              </Badge>
            </div>
            }
            <ReactTooltip />
        </Table.Col>
        <Table.Col>
          <Button type="button"  color="primary" size="sm" icon="plus" onClick={() => {            
            if (typeof onSelectItem !== 'function') return;
            onSelectItem(data);
          }}></Button>
        </Table.Col>
      </Table.Row>
    );
  }
  
  render() {
    const { isOpen, onClosed, onSelectItem } = this.props;
    const { inventoryItems: { items }, isLoading } = this.state;
    
    const searchItem = _.debounce(term => this.handleSearchItem(term), 300);
    const trackScroll = _.debounce(() => this.trackScrolling(), 300);

    return(
      <div className={`right-side-bar ${isOpen ? 'show' : ''}`} ref={this.searchItemSideBarRef} onScroll={trackScroll}>
        <Card className="border-0">
          <Card.Header>
            <Card.Title>Item Search</Card.Title>
            <Card.Options>
              <i className="fe fe-x cursor-pointer" onClick={() => {
                if (typeof onClosed !== 'function') return;
                onClosed();
              }}></i>
            </Card.Options>
          </Card.Header>
          <Card.Body>
            <Form.Group>
              <Form.Input
                icon="search"
                placeholder="Search for..."
                position="append"
                onChange={event => searchItem(event.target.value)}
              />
            </Form.Group>
            <Dimmer active={isLoading} loader>
              <Card>
                <Table className="card-table table-vcenter">
                    <Table.Body>
                        {items.map((item, index) => this.renderItem(item, index, onSelectItem))}
                    </Table.Body>
                </Table>
              </Card>
            </Dimmer>
          </Card.Body>
        </Card>
      </div>
    );
  }
};

export default SearchItemSideBar;


// WEBPACK FOOTER //
// ./src/common/search-item-side-bar.react.js